module.exports = __webpack_public_path__ + "img/haunt_message_box_frame.c00d3fdc.png";